import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReduxBlockUi from 'react-block-ui/redux';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import TimetableSearchForm from './TimetableSearchForm';
import TimetableListView from '../../dashboard/booking/listView';
import queryString from 'query-string';
import { withNamespaces } from 'react-i18next';
import { updateSelectedCenter } from '../../dashboard/actions';
import {
	loadWeeklyProgram,
	SELECTED_CENTER_WEEKLY_PROGRAM_REQUEST, SELECTED_CENTER_WEEKLY_PROGRAM_SUCCESS, SELECTED_CENTER_WEEKLY_PROGRAM_FAILURE,
	loadTermsByCenter, loadGradesByCenter
} from '../../dashboard/common/actions';
import {
	storeSearchQuery, selectProgramItem
} from '../../dashboard/booking/actions';
import {
	loadAgeAppropriateGradesByCenterAndTerm, getAgeAppropriateGradesByChild
} from '../../dashboard/actions';
import analyticsTracker from '../../common/services/analyticsTracker';
import moment from 'moment';
import utils from '../../common/services/utils';

class ProgramList extends Component {
	constructor(props) {
		super(props);

		this.handleCitySelect = this.handleCitySelect.bind(this);
		this.handleCenterSelect = this.handleCenterSelect.bind(this);
		this.handleTermSelect = this.handleTermSelect.bind(this);
		this.handleGradesSelect = this.handleGradesSelect.bind(this);
		this.handleWeekdaySelect = this.handleWeekdaySelect.bind(this);
		this.handleProgramItemSelect = this.handleProgramItemSelect.bind(this);
	}

	componentDidMount() {
		this.reloadData(this.props);
		this.props.storeSearchQuery(this.props.location.search);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.terms.length > 0 && !this.props.searchParams.termId) {
			// init with the first available term
			this.handleTermSelect(nextProps.terms[0].id, true, nextProps.terms);
		}
		if (!nextProps.searchParams.centerId && !nextProps.searchParams.city && nextProps.centers.length > 0) {
			if (nextProps.centers.length === 1) {
				this.handleCenterSelect(nextProps.centers[0].id, true, nextProps.centers);
			}
			else if (nextProps.parentCenter) {
				// init with parent's selected center if parent is logged in
				this.handleCenterSelect(nextProps.parentCenter.id, true, nextProps.centers);
			}
		}

		//if (nextProps.searchParams.termId && nextProps.terms.length > 0 && !nextProps.searchParams.date) {
		//	// set default dates for the selected term
		//	this.handleTermSelect(nextProps.searchParams.termId, true, nextProps.terms);
		//}

		// all search params are in the query string, reload lessons when query string changes
		if (this.props.location.search !== nextProps.location.search) {
			this.props.storeSearchQuery(nextProps.location.search);

			const currentQueryParams = queryString.parse(this.props.location.search);
			const nextQueryParams = queryString.parse(nextProps.location.search);
			if (currentQueryParams.centerId !== nextQueryParams.centerId ||
				currentQueryParams.termId !== nextQueryParams.termId) {
				this.reloadCenterData(nextProps);
				this.reloadWeeklyProgram(nextProps);
				this.reloadAgeAppropriateGrades(nextProps);
			}
		}

		// load lessons after centers are loaded to have access to allowFutureBooking property
		if (((!this.props.selectedCenter || !this.props.selectedCenter.name) && nextProps.selectedCenter && nextProps.selectedCenter.name) ||
			this.props.terms.length === 0 && nextProps.terms.length > 0) {
			this.reloadWeeklyProgram(nextProps);
		}

		// reload age appropriate grades when current parent is loaded
		if (!this.props.parent.id && nextProps.parent.id) {
			this.reloadAgeAppropriateGrades(nextProps);
		}
	}

	reloadData(props) {
		this.reloadCenterData(props);
		this.reloadWeeklyProgram(props);
		this.reloadAgeAppropriateGrades(props);
	}

	reloadCenterData(props) {
		const { searchParams: { centerId }, loadTermsByCenter, loadGradesByCenter } = props;
		if (centerId) {
			loadTermsByCenter(centerId);
			loadGradesByCenter(centerId);
		}
	}

	reloadWeeklyProgram(props) {
		const { searchParams: { centerId, termId, gradeIds }, selectedCenter, loadWeeklyProgram, t, franchisor } = props;
		const selectedTerm = props.terms.find(x => x.id === termId);

		if (selectedCenter && selectedTerm) {
			document.title = t('FO_Document_Title_Book', { center: selectedCenter.name, term: selectedTerm.name });

			// Load program for selected center
			loadWeeklyProgram(centerId, termId,
				null,			// load all grades, filter on display
				[1, 2, 3, 4],	// load all lessons - normal, trial, makeup, single
				true);			// mark as selected center

			// Load program for closest centers
			if (franchisor.recommendNearbyCenters) {
				const closestCenters = utils.findClosestCenters(selectedCenter, props.centers, franchisor.distanceToNearbyCenters);
				closestCenters.forEach(center => {
					loadWeeklyProgram(center.id, termId,
						null,			// load all grades, filter on display
						[1, 2, 3, 4],	// load all lessons - normal, trial, makeup, single
						false);			// mark as not selected center
				});
			}
		}
	}

	reloadAgeAppropriateGrades(props) {
		const { searchParams: { centerId, termId }, parent, loadAgeAppropriateGradesByCenterAndTerm } = props;
		if (centerId && termId && parent.id > 0) {
			loadAgeAppropriateGradesByCenterAndTerm(centerId, termId);
		}
	}

	updateSearchParams(newParam, replaceHistory) {
		const { searchParams, location, history } = this.props;

		const newSearchParams = Object.assign(searchParams, newParam);

		const newPath = {
			pathname: location.pathname,
			search: queryString.stringify(newSearchParams)
		};

		if (replaceHistory) {
			history.replace(newPath);
		} else {
			history.push(newPath);
		}
	}

	handleCitySelect(city) {
		this.updateSearchParams({ city, centerId: null });

		const cityCenters = city ? this.props.centers.filter(x => x.city === city) : this.props.centers;
		if (cityCenters.length === 1) {
			this.handleCenterSelect(cityCenters[0].id, true);
		}
	}

	handleCenterSelect(centerId, replaceHistory, allCenters) {
		const selectedCenterId = Number(centerId);
		if (selectedCenterId) {
			const centers = allCenters || this.props.centers;
			const selectedCenter = centers.find(x => x.id === selectedCenterId);

			this.updateSearchParams({
				city: selectedCenter && selectedCenter.city,
				centerId: selectedCenterId
			}, replaceHistory);

			if (selectedCenter) {
				analyticsTracker.trackEvent('SelectedCentre', {
					name: selectedCenter.name
				});
			}

			if (this.props.parent.id > 0) { // update parent's center if parent is logged in
				this.props.updateSelectedCenter(selectedCenterId, this.props.history, false);
			}
		}
	}

	handleTermSelect(termId, replaceHistory, allTerms) {
		const selectedTermId = Number(termId);
		if (selectedTermId) {
			this.updateSearchParams({ termId: selectedTermId }, replaceHistory);
		}
	}

	handleGradesSelect(gradeIds) {
		this.updateSearchParams({ gradeIds });
	}

	handleWeekdaySelect(weekday) {
		this.updateSearchParams({ weekday: weekday ? Number(weekday) : null });
	}

	handleProgramItemSelect(item) {
		this.props.selectProgramItem(item.id);

		const { lessonType } = this.props.searchParams;
		this.props.history.push(`/public/timetable/${item.centerId}/${item.id}?lessonType=${lessonType}`, { fromTimetable: true });
	}

	render() {
		const { cities, centers, selectedCenter, terms, grades, weeklyProgram, franchisor, allowWorkshops, enableUserTimeZone, t } = this.props;
		const { city, centerId, termId, gradeIds, weekday, lessonType } = this.props.searchParams;

		const selectedCity = city;
		const selectedTerm = terms.find(x => x.id === termId);
		const selectedGrades = gradeIds ? grades.filter(grade => gradeIds.indexOf(grade.id) > -1) : [];

		const programInSelectedCenterTermGrades = weeklyProgram.filter(x =>
			!x.hidden &&
			x.centerId === centerId &&
			x.termId === termId &&
			(!gradeIds || gradeIds.indexOf(x.gradeId) > -1 || (x.grade.mixed && x.grade.subGrades && x.grade.subGrades.some(s => gradeIds.indexOf(s) > -1))) &&
			(!weekday || x.weekday === weekday));

		return <div className='timetable-wrapper'>
			<ReduxBlockUi block={SELECTED_CENTER_WEEKLY_PROGRAM_REQUEST} unblock={[SELECTED_CENTER_WEEKLY_PROGRAM_SUCCESS, SELECTED_CENTER_WEEKLY_PROGRAM_FAILURE]}>
				<Row>
					<Col md={12}>
						<TimetableSearchForm
							cities={cities}
							centers={centers}
							terms={terms}
							grades={grades.filter(x => !x.mixed)}
							showWeekdays
							selectedCity={selectedCity}
							selectedCenter={selectedCenter}
							selectedTerm={selectedTerm}
							selectedGrades={selectedGrades}
							selectedWeekday={weekday}
							onSelectCity={this.handleCitySelect}
							onSelectCenter={this.handleCenterSelect}
							onSelectTerm={this.handleTermSelect}
							onSelectGrades={this.handleGradesSelect}
							onSelectWeekday={this.handleWeekdaySelect}
							franchisorDisplayName={franchisor.displayName}
						/>
					</Col>
				</Row>
				<TimetableListView
					lessonType={lessonType}
					center={selectedCenter}
					weeklyProgram={programInSelectedCenterTermGrades}
					onSelectProgramItem={this.handleProgramItemSelect}
					enableUserTimeZone={enableUserTimeZone}
					paymentTypes={this.props.paymentTypes}
				/>
				<Row style={{ paddingTop: '10px' }} className='timetable-options'>
					<Col sm={12}>
						{allowWorkshops && <Link className='btn btn-primary btn-block-xxs pull-right' to={`/public/workshops?centerId=${centerId}`}>{t('FO_MainMenu_Parent_Workshops')} <FontAwesome name='arrow-circle-right' /></Link>}
						<Link className='btn btn-back btn-block-xxs' to={`/public/centers?reset=true&lessonType=${lessonType}`}><FontAwesome name='arrow-circle-left' /> {t('FO_Booking_Center_Select')}</Link>
					</Col>
				</Row>
			</ReduxBlockUi>
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const { entities: { centers, grades, terms, weeklyProgram }, configuration: { franchisor }, parent } = state;

	const queryParams = queryString.parse(ownProps.location.search);
	const lessonType = queryParams.lessonType;

	const parentCenterId = parent.centerId;
	const parentCenter = parentCenterId ? centers[parentCenterId] : null;

	let weeklyProgramDeepLoaded = Object.values(weeklyProgram);
	weeklyProgramDeepLoaded.forEach(item => {
		item.grade = grades[item.gradeId] || { name: '', subGrades: [] };
		item.center = centers[item.centerId] || { name: '' };
		item.term = terms[item.termId] || { name: '', schoolYear: '' };
	});

	const allChildren = state.parent.children;
	allChildren.forEach(child => {
		let ageAppropriateGradeIds = child.ageAppropriateGradeIds || [];
		if (queryParams.centerId && queryParams.termId) {
			ageAppropriateGradeIds = getAgeAppropriateGradesByChild(state.parent, queryParams.centerId, queryParams.termId, child.id) || [];
		}

		child.ageAppropriateGrades = ageAppropriateGradeIds.map(gradeId => grades[gradeId]);
	});

	const selectedCenterId = queryParams.centerId ? Number(queryParams.centerId) : null;
	const selectedCenter = selectedCenterId && centers[selectedCenterId];

	let selectedGradeIds = null;
	if (queryParams.gradeIds) {
		let gradeIdsParamValues = [queryParams.gradeIds];
		if (Array.isArray(queryParams.gradeIds)) {
			gradeIdsParamValues = [...queryParams.gradeIds];
		}
		selectedGradeIds = gradeIdsParamValues.map(id => Number(id));
	}

	let selectedWeekday = queryParams.weekday ? Number(queryParams.weekday) : null;

	return {
		franchisor,
		grades: selectedCenter && selectedCenter.grades ?
			selectedCenter.grades.map(id => grades[id]).filter(x => !!x) : [],
		parentCenter,
		searchParams: {
			city: queryParams.city,
			centerId: selectedCenterId,
			termId: queryParams.termId ? Number(queryParams.termId) : null,
			gradeIds: selectedGradeIds,
			lessonType: lessonType || '',	// load all booking options by default - normal and trial
			weekday: selectedWeekday
		},
		parent,
		centers: Object.values(centers).filter(c => lessonType !== 'trial' || c.isTrialLesson).sort((a, b) => a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1),
		selectedCenter,
		cities: [...new Set(Object.values(centers).map(center => center.city))],	// distinct list of cities with centers
		terms: selectedCenter && selectedCenter.terms ?
			selectedCenter.terms
				.map(x => ({ ...terms[x.id], ...x }))	 // replace startDate and endDate with actual working period for the selected term
				.filter(x => x.allowBooking)
				.sort(function (a, b) {
					return moment(a.startDate).format('YYYYMMDD') - moment(b.startDate).format('YYYYMMDD');
				})
			: [],
		weeklyProgram: weeklyProgramDeepLoaded,
		children: allChildren,
		allowWorkshops: franchisor && franchisor.enableWorkshops && Object.values(centers).some(c => c.isWorkshops),
		enableUserTimeZone: franchisor && franchisor.enableUserTimeZone,
		paymentTypes: state.lookups.paymentTypes
	};
};

export default connect(mapStateToProps, {
	loadTermsByCenter,
	loadGradesByCenter,
	loadAgeAppropriateGradesByCenterAndTerm,
	loadWeeklyProgram,
	updateSelectedCenter,
	storeSearchQuery,
	selectProgramItem
})(withNamespaces()(ProgramList));